var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAll = function SvgAll(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2359FB",
    d: "M19.148 6.494c.568-.596.247-1.634-.293-2.152C7.538-1.966-.791 11.08 3.695 21.582l.149.033c5.71-3.187 11.714 3.515 17.582.444.575-.256 1.513-.713 1.574-1.396-3.979-.48-13.718-7.162-8.783-11.309 1.492.798 2.697 2.403 4.57 2.106 1.97-.596.85-3.277-.27-4.205-.17-.164-.617-.21-.173-.387.264-.105.565-.124.804-.374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "M16.453 5.033c1.846.522 4.944 2.62 4.592 4.814-.089.552-.446.743-.98.744-3.408-.798-5.64-5.21-10.177-4.288a.846.846 0 0 0-.69.978c3.827-.924 3.802 2.566-.19 2.654-.738.15-2.845.497-2.11 1.683 4.15-1.708 7.162 2.332 4.146 3.385-1.218.255-2.463-.182-3.751.07-3.18.625-3.049 4.024-3.57 6.578-5.35-9.117 2.512-21.818 13.272-19.335.978.175 3.573.947 3.63 2.158-.776 2.652-4.364-1.61-4.172.559"
  })));
};
export default SvgAll;